import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import actions from "../actions/actions";
import { message } from "antd";

const getAddresses =
	({ address, types, meterCode, allAddress, tags }) =>
		async (dispatch) => {
		try {
			dispatch({
				type: actions.LIST_LOADING,
			});
			const { data } = await client.get(
				`/Meter/addresses?${
					types?.length
						? `${types.map((type) => `types=${type}`).join("&")}`
						: ""
				}&${
					tags?.length ? `${tags.map((tag) => `tags=${tag}`).join("&")}` : ""
				}`,
				{
					headers: authHeader(),
					params: {
						allAddress,
						meterCode,
						address,
					},
				}
			);
			dispatch({
				type: actions.ADDRESSES_LOADED,
				payload: data,
			});
		} catch (e) {
			console.error(e);
			message.error("При загрузке адресов произошла ошибка");
		}
	};

export default getAddresses;
